module.exports = __webpack_public_path__ + "media/click.b019aadf.wav";